.section {
  margin: 16px 0;
}

.filters {
  margin-bottom: 16px;
}

.adminIdInput {
  width: 150px;
}

.actionSelect {
  width: 200px;
}

.targetSelect {
  width: 150px;
}

.statusSelect {
  width: 120px;
}

.rangePicker {
  width: 300px;
}

.strong {
  font-weight: 500;
}

.small {
  font-size: 12px;
}

.detailSection {
  margin-top: 24px;
}

.json {
  max-height: 400px;
  padding: 12px;
  margin: 0;
  overflow-y: auto;
  font-family: Monaco, Menlo, Consolas, monospace;
  font-size: 12px;
  line-height: 1.6;
  color: var(--ant-color-text);
  background: var(--ant-color-fill-tertiary);
  border-radius: var(--ant-border-radius-sm);
}

.breakAll {
  font-size: 13px;
  word-break: break-all;
}
